<template>
  <div class="edit-customer-type-container">
    <h2>Edit type</h2>
    <form class="form" @submit="editType" autocomplete="off">
      <div class="form-group">
        <label class="form-label">Name *
          <input v-model="name" class="form-control" :class="displayError ? 'form-control-error' : null" @input="validateInput" v-bind:style="{ 'background-color': activeColor?.hex_value || '#FFF' }">
        </label>
      </div>
      <h2>Select Color</h2>
      <div class="form-group">
        <div v-for="color in colors" @click="setActiveColor(color)" :key="color?.id" class="color-container" v-bind:class="{ 'color-container--active': activeColor?.id == color?.id }" v-bind:style="{ 'background-color': color?.hex_value || '#FFF' }">{{color?.name || 'Blank'}}</div>
        <div @click="setActiveColor(null)" v-bind:style="{ 'background-color': '#FFF' }" class="color-container" :class="{'color-container--active': activeColor === null }">Blank</div>
      </div>
      <div class="buttons">
        <p class="error-message" v-if="displayError">Please correct the highlighted field.</p>
        <button type="submit" class="btn btn--primary" :disabled="name === null || name == '' || displayError">Save</button>
        <button @click="cancel" class="btn btn--warning">Cancel</button>
      </div>
    </form>
  </div>
</template>

<script>
import api from '../../api'
export default {
  name: 'EditCustomerType',
  emits: ['customerTypeUpdated', 'customerTypeCancel'],
  props: {
    type: {
      default: null
    },
  },
  data() {
    return {
      activeColor: null,
      name: this.$props.type.name,
      colors: [],
      displayError: false,
    }
  },
  mounted() {
    this.activeColor = this.type.type_color
    api.getTypeColors().then(response => {
      this.colors = response.data.records
    })
  },
  methods: {
    editType(e) {
      e.preventDefault()
      api.updateCustomerType({ name: this.name, id: this.$props.type.id, type_color_id: this.activeColor?.id || null }).then(res => {
        this.$emit('customerTypeUpdated', res.data.record.id);
        console.log(res);
      })
    },
    cancel() {
      this.$emit('customerTypeCancel')
    },
    validateInput() {
      if (!/^[a-zA-Z\s&\d]*$/.test(this.name)) {
        this.displayError = true
        return
      }
      this.displayError = false
    },
    setActiveColor(color) {
      this.activeColor = color
    }
  },
}
</script>
<style scoped>
.customer-type-container {
    margin-top: 0.4375rem;
    border: 1px solid #E5E5E5;
    position: relative;
    background: white;
    padding-left: 15px;
}

.color-container {
  border: 1px solid #E5E5E5;
  box-sizing: border-box;
  height: 40px;
  margin: 10px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 12px;
  padding-left: 20px;
}

.color-container--active {
  border: 1px solid black;
}

.color-container:hover {
  border: 1px solid black;
}

.form-control-error {
  border: 1px solid #D43F21;
}

.error-message {
  color: red;
  margin-bottom: 10px;
}
@media screen and (max-width: 992px) {
  .edit-customer-type-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>
